import React from 'react';
import { Building2, Factory, Ship, Cog, Wrench, BrickWall } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { industries } from '../data/mock';

const iconMap = {
  Building2: Building2,
  BrickWall: BrickWall,
  Factory: Factory,
  Ship: Ship,
  Cog: Cog,
  Wrench: Wrench
};

const IndustriesSection = () => {
  return (
    <section id="industries" className="py-20 bg-zinc-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(234,88,12,0.05)_1px,transparent_1px),linear-gradient(to_bottom,rgba(234,88,12,0.05)_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-orange-500 text-sm font-bold tracking-wider uppercase">Industries We Serve</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Powering <span className="text-orange-500">Multiple Industries</span>
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            From construction sites to manufacturing plants, our equipment meets the rigorous demands of diverse industrial applications
          </p>
          <div className="w-24 h-1 bg-orange-600 mx-auto mt-6"></div>
        </div>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => {
            const IconComponent = iconMap[industry.icon];
            return (
              <Card 
                key={index}
                className="bg-zinc-800/50 backdrop-blur-sm border-zinc-700 hover:border-orange-600/50 transition-all duration-300 group"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <CardContent className="p-6 flex flex-col items-center text-center">
                  {/* Icon Container */}
                  <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-600 to-orange-700 flex items-center justify-center mb-5 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-orange-600/30 transition-all duration-300">
                    <IconComponent className="w-10 h-10 text-white" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-white mb-3 group-hover:text-orange-500 transition-colors">
                    {industry.name}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed">
                    {industry.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center p-6 bg-zinc-800/30 backdrop-blur-sm border border-zinc-800 rounded-xl">
            <div className="text-3xl font-bold text-orange-500 mb-2">500+</div>
            <div className="text-zinc-400 text-sm">Industrial Clients</div>
          </div>
          <div className="text-center p-6 bg-zinc-800/30 backdrop-blur-sm border border-zinc-800 rounded-xl">
            <div className="text-3xl font-bold text-orange-500 mb-2">50+</div>
            <div className="text-zinc-400 text-sm">Cities Covered</div>
          </div>
          <div className="text-center p-6 bg-zinc-800/30 backdrop-blur-sm border border-zinc-800 rounded-xl">
            <div className="text-3xl font-bold text-orange-500 mb-2">24/7</div>
            <div className="text-zinc-400 text-sm">Support Available</div>
          </div>
          <div className="text-center p-6 bg-zinc-800/30 backdrop-blur-sm border border-zinc-800 rounded-xl">
            <div className="text-3xl font-bold text-orange-500 mb-2">100%</div>
            <div className="text-zinc-400 text-sm">Quality Assured</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;